var _g, _path, _rect, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoCamionVacio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 15,
    fill: "#4F4184"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 14.5,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7143 20.5353H26.2857V17.5219C26.2857 17.1871 26.125 16.8244 25.8839 16.5732L23.2321 13.811C22.9911 13.5598 22.6429 13.3924 22.3214 13.3924H20.9714V12.0744C20.9714 11.349 20.5536 10.7139 19.8571 10.7139H11.2857C10.5625 10.7139 10 11.3277 10 12.0532V20.9817C10 21.7351 10.5625 22.321 11.2857 22.321H11.7143C11.7143 23.7998 12.8661 24.9996 14.2857 24.9996C15.7054 24.9996 16.8571 23.7998 16.8571 22.321H20.2857C20.2857 23.7998 21.4375 24.9996 22.8571 24.9996C24.2768 24.9996 25.4286 23.7998 25.4286 22.321H26.7143C26.9286 22.321 27.1428 22.1257 27.1428 21.8746V20.9817C27.1428 20.7585 26.9286 20.5353 26.7143 20.5353ZM14.2857 23.6603C13.5625 23.6603 13 23.0744 13 22.321C13 21.5956 13.5625 20.9817 14.2857 20.9817C14.9821 20.9817 15.5714 21.5956 15.5714 22.321C15.5714 23.0744 14.9821 23.6603 14.2857 23.6603ZM22.8571 23.6603C22.1339 23.6603 21.5714 23.0744 21.5714 22.321C21.5714 21.5956 22.1339 20.9817 22.8571 20.9817C23.5536 20.9817 24.1428 21.5956 24.1428 22.321C24.1428 23.0744 23.5536 23.6603 22.8571 23.6603ZM25 17.8567H21.1429V14.7317H22.3214L25 17.5219V17.8567Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.5,
    width: 10.4286,
    height: 9.71428,
    rx: 0.5,
    fill: "#4F4184",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCamionVacio);
export default __webpack_public_path__ + "static/media/LogoCamionVacio.5e687ee2.svg";
export { ForwardRef as ReactComponent };